export default "__VITE_PUBLIC_ASSET__3e0c9a4f__"